import { CellContext } from '@tanstack/react-table';
import { vars } from 'src/core/themes';

import { BaseCellProps } from './BaseCell';
import * as styles from './IconTagCell.css';
import { IconTextCell } from './IconTextCell';

export interface IconTagCellProps<
  TData = unknown,
  TValue = unknown,
> extends Omit<BaseCellProps, 'children'> {
  context?: CellContext<TData, TValue>;
  iconLeftContent: React.ReactNode;
  text: string;
  value?: TValue;
  showPadding?: boolean;
  fullWidth?: boolean;
  iconRight?: React.ReactNode;
}

export function IconTagCell<TData, TValue>({
  iconLeftContent,
  text,
  iconRight,
}: IconTagCellProps<TData, TValue>) {
  const iconLeft = iconLeftContent ? (
    <div className={styles.iconLeft}>{iconLeftContent}</div>
  ) : null;
  return (
    <IconTextCell
      style={{ padding: `${vars.spacing['xxs']}` }}
      cellStyle={{
        padding: `${vars.spacing['xxs']}`,
        height: '100%',
        width: 'fit-content',
        borderRadius: vars.borderRadius.s,
        backgroundColor: vars.color.surfaceSecondary,
        alignItems: 'center',
        textTransform: 'none',
        display: 'flex',
      }}
      iconLeft={iconLeft}
      text={text}
      iconRight={iconRight}
    />
  );
}
